import ahoy from "ahoy.js";
if (process.env.NODE_ENV === "development") {
    ahoy.debug();
}
ahoy.configure({ cookies: false });
ahoy.trackView();
